var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { class: ["content bg-light", { expanded: !_vm.isSidebarOpen }] },
          [
            _c(
              "div",
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "div",
                      { staticClass: "content-title" },
                      [
                        _c("b-row", [_c("h1", [_vm._v("User Management")])]),
                        _vm._v(" "),
                        _c("b-row", [
                          _c("span", [
                            _vm._v("Manage user accounts and permissions"),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "stats" },
                      _vm._l(_vm.stats, function (stat, index) {
                        return _c(
                          "b-col",
                          {
                            key: index,
                            on: {
                              click: function ($event) {
                                stat.status != null
                                  ? _vm.selectStatus(stat.status)
                                  : ""
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c("span", { style: { color: stat.color } }, [
                                _vm._v(_vm._s(stat.number)),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(stat.title))]),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }